import { Injectable, OnInit } from "@angular/core";
import { LexTranslateService } from "@app/core/services/lex-translate.service";

@Injectable({
  providedIn: "root",
})
export class ErrorMessages implements OnInit {

  constructor(public lextranslate: LexTranslateService) { }

  async ngOnInit(): Promise<void> {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()
  }

  public getServiceDefault(): string {
    return `${this.lextranslate.i18n['0e674734-b577-424b-a0d3-66c57cf9371c']}`
  }

  public getSessionExpiredRedirect(): string {
    return this.lextranslate.i18n['6cb5b6d2-8553-415c-b572-3262330494be']
  }
}
